import React, { useState } from 'react';
import { Container, Nav, Navbar, Row, Col, Card, Button, Modal } from 'react-bootstrap';
import { PlayCircle } from 'lucide-react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './about.css';
import { Link } from 'react-router-dom';

function About() {
  const [showModal, setShowModal] = useState(false);

  const handleVideoClick = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <div>
      {/* Navigation Bar */}
      {/* <Navbar className="custom-navbar" variant="dark">
        <Container>
          <Navbar.Text className="text-light small text-uppercase letter-spacing-1 fw-semibold">
            NETWORKING | SOFTWARE | WEB SERVICES
          </Navbar.Text>
        </Container>
      </Navbar> */}

      {/* Main Content */}
      <Container className="py-5">
        <Row className="align-items-center gy-4">
          {/* Left Content */}
          <Col lg={6}>
            <h1 className="main-heading">Welcome to CSC IIT Delhi</h1>
            <p className="lead text-muted mb-4">
              Our mission at CSC is to provide sustainable and reliable academic and administrative
              technology services. We are dedicated towards strengthening the Institute's mission of
              achieving excellence in academia & research, student-centered learning and institutional
              efficacy through best-in-class IT services.
            </p>
            <Link to="/getting-started" className='text-white text-decoration-none border-0'>
            <Button
              size="lg"
              className="custom-btn"
            >
              Getting Started
            </Button>
              </Link>
          </Col>

          {/* Right Content - Video Thumbnail */}
          <Col lg={6}>
            <div className="video-container">
              <div className="thumbnail-container">
                <img 
                  src="https://home.iitd.ac.in/images/for-faculty/camp8.jpg" 
                  alt="IIT Delhi Campus" 
                  className="thumbnail-image"
                />
                <div className="video-overlay" onClick={handleVideoClick}>
                  <div className="play-button">
                    <PlayCircle size={48}  color='#c21717'/>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Services Section */}

      {/* Video Modal */}
      <Modal 
        show={showModal} 
        onHide={handleCloseModal} 
        size="lg"
        centered
        className="video-modal"
      >
        <Modal.Body className="p-0">
          <div className="ratio ratio-16x9">
            <iframe
              src={showModal ? "https://www.youtube.com/embed/aEgnRafIlfY?autoplay=1" : ""}
              title="IIT Delhi Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default About;